export const environment = {
    production: true,
    envName: 'prod',
    baseApiUrl: 'https://loops.unionhomemortgage.com/loops-api/',
    oauthRedirectUri: '/loops/',
    propertyFields: [{ key: "Fields.1041", value: "Prop Type (Field 1041)" },
    { key: "Fields.1553", value: "ULDD Prop Type (Field 1553)" }
    ]
};



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/environments/environment.ts